<template>
  <div>
    <RequestFeedback :showRequestFeedback="showRequestFeedback" @close="showRequestFeedback = false"></RequestFeedback>
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex flex-wrap lg:gap-0 gap-4 justify-between items-center p-3">
        <div class="flex gap-3">
          <div
            v-for="(tab, index) in visibleTabs"
            :key="index"
            @click="changeTab(tab.title)"
            :class="{
              ' text-white bg-primary': selectedTab == tab.title,
            }"
            class="text-sm text-center hover:bg-primary bg-gray-200 hover:text-white cursor-pointer p-3"
          >
            {{ tab.title }}
          </div>
        </div>
<!--        <div class="flex gap-4">
          <input
            v-if="selectedTab == 'Feedback Received'"
            type="text"
            placeholder="Search Goal"
            class="rounded-xl w-full pl-4 py-1 bg-gray-200 text-sm"
          />
          <input
            v-if="selectedTab == 'Feedback Given'"
            type="text"
            placeholder="Search Competency"
            class="rounded-xl w-full pl-4 py-1 bg-gray-200 text-sm"
          />
          <input
            type="text"
            onfocus="(this.type='date')"
            onbur="(this.type='text')"
            placeholder="Due Date"
            class="rounded-xl w-full pl-4 py-1 bg-gray-200 text-sm"
          />
        </div>-->
        <button
          @click="showRequestFeedback = true"
          class="bg-primary text-white rounded-full px-3 py-1 text-sm"
          v-if="requestFeedbackOption"
        >
          Request Feedback
        </button>
      </div>
      <Goals :key="gKey" v-if="selectedTab == 'Feedback Received'"></Goals>
      <Compentencies
        :key="cKey"
        v-if="selectedTab == 'Feedback Given'"
      ></Compentencies>
      <GiveFeedback :key="gfKey" v-if="selectedTab==='Give Feedback'"></GiveFeedback>
    </div>

  </div>
</template>

<script>
import Goals from "./360Evaluation/goals.vue";
import Compentencies from "./360Evaluation/compentencies.vue";
import RequestFeedback from "./360Evaluation/requestFeedback.vue"
import GiveFeedback from "./360Evaluation/giveFeedback"
import axios from "axios";
import {mapGetters} from "vuex";
export default {
  name: "360Evaluation",
  components: { Goals, Compentencies, RequestFeedback, GiveFeedback },
  data() {
    return {
      selectedTab: "Give Feedback",
      showRequestFeedback: false,
      frKey: 0,
      fgKey: 1,
      tabs:[
        {
          title:'Give Feedback',
          visible:false
        },
        {
          title:'Feedback Requests',
          visible:false
        },
        {
          title:'Feedback Received',
          visible:false
        },
      ],
      requestFeedbackOption:false,
      giveFeedbackOption:false,
      higherLevelEmployees:[],
      lowerLevelEmployees:[],
      sameLevelEmployees:[]
    };
  },
  computed:{
    ...mapGetters(["getOrganization", "getToken"]),
    visibleTabs() {
      return this.tabs.filter((tab) => tab.visible);
    },
  },
  created() {
    this.getFeedbackSetting()
    this.getEmployees()
  },
  methods: {
    changeTab(tab) {
      this.selectedTab = tab;
      switch (this.selectedTab) {
        case "Feedback Received":
          this.frKey++;
          break;
        case "Feedback Given":
          this.fgKey++;
          break;
      }
    },
    getFeedbackSetting(){
      this.loading = true;
      let url = `${this.getOrganization}/performance/360evaluation/setup/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode === 200) {
              const data = response.data.Data;
              this.requestFeedbackOption = data.RequestFeedback;
              this.giveFeedbackOption = data.GiveFeedback;
              this.updateTabsVisibility();
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
      );
    },
    updateTabsVisibility() {
      this.tabs = this.tabs.map((tab) => {
        if (tab.title === "Give Feedback") {
          tab.visible = this.giveFeedbackOption;
        } else if (tab.title === "Feedback Requests") {
          tab.visible = this.requestFeedbackOption;
        } else if (tab.title === "Feedback Received") {
          tab.visible =
              this.giveFeedbackOption || this.requestFeedbackOption;
        }
        return tab;
      });
      const firstVisibleTab = this.tabs.find((tab) => tab.visible);
      this.selectedTab = firstVisibleTab ? firstVisibleTab.title : "";
    },
    getEmployees(){
      this.loading = true
      let url = `${this.getOrganization}/performance/360evaluation/employee/hierarchy/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode === 200) {
              console.log(response.data.Data)
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
      );

    }
  },

};
</script>
